import { supabase } from "@/lib/supabaseClient";

/**
 * Helper: checks session → navigates to /checkout or redirects to signup with intent.
 */
export async function handleProPlanClick(navigate: (path: string) => void): Promise<boolean> {
  const { data: { session } } = await supabase.auth.getSession();

  if (!session) {
    sessionStorage.setItem("autocarbid_plan_intent", "pro");
    navigate("/cadastro");
    return false;
  }

  return true;
}
